import React, { Component } from 'react';
import * as PropTypes from 'prop-types';

import './Toast.sass';

class Toast extends Component {
  componentDidMount() {
    const { sticky, timeout, dismiss, id } = this.props;
    if (!sticky) {
      setTimeout(() => dismiss(id), timeout);
    }
  }

  render() {
    const {
      id,
      category,
      sticky,
      dismiss,
      inverted,
      showIcon,
      children,
    } = this.props;
    let classes = 'toast toast-' + category;
    if (inverted) {
      classes += ' inverted';
    }

    let icon = '';
    if (showIcon) {
      switch (category) {
        case 'info':
          icon = 'fa fa-info-circle';
          break;
        case 'success':
          icon = 'fa fa-check-circle';
          break;
        case 'warning':
          icon = 'fa fa-exclamation-circle';
          break;
        case 'error':
          icon = 'fa fa-exclamation-triangle';
          break;
        default:
          break;
      }
    }

    if (sticky && dismiss) {
      return (
        <div className={classes}>
          <button
            type="button"
            className="close float-end"
            onClick={() => dismiss(id)}
          >
            <span>&times;</span>
          </button>
          {showIcon && <i className={icon} />} {children}
        </div>
      );
    } else {
      return (
        <div className={classes}>
          {showIcon && <i className={icon} />} {children}
        </div>
      );
    }
  }
}

Toast.propTypes = {
  id: PropTypes.number.isRequired,
  dismiss: PropTypes.func.isRequired,
  category: PropTypes.oneOf(['info', 'success', 'warning', 'error']),
  sticky: PropTypes.bool,
  timeout: PropTypes.number,
  inverted: PropTypes.bool,
  showIcon: PropTypes.bool,
};
Toast.defaultProps = {
  category: 'info',
  sticky: false,
  timeout: 3000,
  inverted: false,
  showIcon: true,
};

export default Toast;
